module.exports = __webpack_public_path__ + "static/img/IMG_20170305_122619.091749af.jpg";